import apiClientCreator from "../../helpers/api/request";

export async function getSystemDictionary({ commit, state }) {
  try {
    let apiClient = apiClientCreator("system/dictionary");
    let response = await apiClient.get();
    commit("system/setSystemDictionary", response.data, { root: true });
    return response;
  } catch (e) {}
}